import request from '@/utils/request';

export function getProjectList(params) {
  return request({
    url: `/icbc/donations`,
    method: 'get',
    params
  });
}
export function payProject(data) {
  return request({
    url: `/icbc/donation/h5/pay`,
    method: 'post',
    data
  });
}
